<template>
  <div class="c-section-item">
    <slot/>
  </div>
</template>

<style lang="scss">
  .c-section-item {
    display: flex;
    align-items: center;
    padding: $space-normal;
    gap: $space-big;

    > * {
      flex-grow: 1;
      min-width: 0;
    }

    > .c-direction-icon {
      flex-grow: 0;
      margin-left: auto;
      color: $neutral-500;
    }
  }
</style>